import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

const AddressLabel = ({address}) => {

    return (
        <div className="d-flex flex-row align-items-center justify-content-center border-left ml-4 pl-4">
            <FontAwesomeIcon color="#82ca9d" icon="map-marker-alt"/>
            <p className="font-weight-light p-0 m-0 pl-2">{address}</p>
        </div>
    )

}

AddressLabel.propTypes = {
    address: PropTypes.string.isRequired
}

export default AddressLabel